import axios from "axios";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Paginate from "../components/Paginate";
import { Table, Button, Row, Col } from "react-bootstrap";
import { PRODUCT_CREATE_RESET } from "../constants/productConst";
import { REGISTER_EVENT_LIST_SUCCESS } from "../constants/resgistertEventConst";
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router-dom";
import { Pagination } from "react-bootstrap";
// import User from '../../../backend/models/userModel';
import {
  listregisterevents,
  deleteregisterevent,
  createregisterevent,
} from "../actions/registereventActions";
import copy from "copy-to-clipboard";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//import Modal from "react-modal";
import UsereventScreen from "../screens/UsereventScreen";
import EditRegistry from "../screens/EditRegistryScreen";

const RegistereventListScreen = ({ isAdmin = false, keyword = "" }) => {
  // const pageSize=8
  // const page=Number(query.pageNumber) || 1
  // const pageNumber=match.params.pageNumber || 1
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const [products, setProducts] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [storeDetails, setStoreDetails] = useState([]);
  const createdDate = new Date().toISOString();
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [showEditRegistry, setShowEditRegistry] = useState(false);
  const [showReventScreen, setShowReventScreen] = useState(false);

  useEffect(() => {
    if (window.Shopline.customer !== undefined) {
      axios
        .get(
          `https://wiser-ai.expertvillagemedia.com/api/getregistry/${window.Shopline.handle}/${window.Shopline.customer.id}`
        )
        .then((res) => {
          //console.log("3333333333333333333333333");
          //console.log(res);
          //console.log("444444444444444444444444");
          setProducts(res.data.data);
          //console.log(res.data);
          const createdDate = new Date().toISOString();
          //console.log("55555555555555555555555555");
          //console.log(createdDate);
        });
      fetchProducts(page);
      //console.log('Log this'+products+"+++");
    }
  }, [page]);

  const fetchProducts = async (pageNumber) => {
    try {
      //const response = await axios.get(`https://wiser-ai.expertvillagemedia.com/api/getregistry/${window.Shopline.handle}`);
      axios
        .get(
          `https://wiser-ai.expertvillagemedia.com/api/getregistry/${window.Shopline.handle}/${window.Shopline.customer.id}`
        )
        .then((res) => {
          setProducts(res.data.data);
          const createdDate = new Date().toISOString();
        });
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const handleTabClick = () => {};

  const handlePageChange = (pageNumber) => {
    //setPage(pageNumber);
  };

  const config = {
    headers: {
      //Authorization:`Bearer ${userInfo.token}`
    },
  };

  const addClassOnBody = () =>{
    document.body.classList.add('evmModalBoxOverlay');
  }



  /** DELETE CUSTOMER HANDLE */
  const deleteHandler = async (id) => {
    //if (window.confirm('Are you sure?')) {
    const AppEndPointURL = `https://wiser-ai.expertvillagemedia.com/api/deleteregistry/${id}`;
    try {
      // Delete the product using axios
      await axios.get(AppEndPointURL, config);
      // Fetch updated products after successful deletion
      /*const response = await axios.get(`/api/registarevent/?pageNumber=${page}&limit=5`);
          const { registerevents, pages } = response.data;
          setProducts(registerevents);
          setPages(pages);
          */
      axios
        .get(
          `https://wiser-ai.expertvillagemedia.com/api/getregistry/${window.Shopline.handle}/${window.Shopline.customer.id}`
        )
        .then((res) => {
          setProducts(res.data.data);
          const createdDate = new Date().toISOString();
        });
      toast("Giftregistry deleted successfully.!");
      //alert('Registry successfully deleted');
    } catch (error) {
      console.error("Error deleting product:", error);
    }
    //}
  };

  const addProGiftRegistry = async (id) => {
    localStorage.setItem("gift_registry_id", id);
    window.location.href = `https://${window.Shopline.handle}.myshopline.com/collections`;
  };

  const shareProduct = (productId) => {
    // Generate the shareable link based on your app's URL structure
    const shareableLink = `https://${window.Shopline.handle}.myshopline.com/pages/evmnew/?evm_shared_giftregistry=${productId}`;    
    // Copy the link to the clipboard
    copy(shareableLink);    
    // You can also provide feedback to the user that the link has been copied    
    toast('Giftregistry link copied to clipboard!');
  };

  const formatDate = (datestr) => {
    var options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(datestr).toDateString([], options);
  };
  
  const editRegistryCancelBtnClick = () => {
    setShowEditRegistry(false);
    setSelectedData({});
  };

  const reventScreenCancelBtnClick = () => {
    setShowReventScreen(false);
    setSelectedData({});
  };

  // Check if current state is for edit or not
  if (showEditRegistry) {
    return (
      <EditRegistry
        registryId={selectedData.id}
        editRegistryCancelBtnClick={editRegistryCancelBtnClick}
      />
    );
  }

  if (showReventScreen) {
    return (
      <UsereventScreen
        data={selectedData}
        reventScreenCancelBtnClick={reventScreenCancelBtnClick}
      />
    );
  }

  /** CODE FOR OPEN MODEL END */

  return (
    <div className="evm-manage-product">
      {window.Shopline.customer === undefined && (
        <div className="create-registry-wr">
          <h1>Please login before to access gift registry</h1>
          <a href="/user/signIn">Sign In</a>
        </div>
      )}
      {window.Shopline.customer !== "" &&
        window.Shopline.customer !== undefined && (
          <table className="table table-bordered searchlist_responsive manage-table-list table_custom">
            <thead className="sm_d_none">
              <tr>
                <th style={{ width: "auto" }} className="">S.No.</th>                
                <th style={{ width: "auto" }}>Event Name</th>
                <th style={{ width: "15%" }} className="">Event Date</th>                
                <th style={{ width: "15%" }} className="">Registraint Name</th>
                <th style={{ width: "15%" }} className="">Registry Owner</th>
                <th style={{ width: '15%' }} className="">Share</th>
                <th style={{ width: "auto" }} className="ifcustomer">Add Products In Gift Registry</th>
                <th style={{ width: "auto" }} className="ifcustomer">Actions</th>
              </tr>
            </thead>
            <tbody>
              {products.length === 0 ? (
                <tr>
                  <td colSpan="8">
                    <p>No Gift Rregistry found.</p>                    
                  </td>
                </tr>
              ) : (
                products.map((product, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{product.regtype}</td>
                    <td>{formatDate(product.regdate)}</td>
                    <td>{product.r_fname}{' '}{product.r_lname}</td>
                    <td>{product.customer_name}</td>
                    <td><Button variant='primary' className='btn-sm' onClick={() => shareProduct(product.id)}>Share</Button></td>
                    <td><Button variant="add" className="btn btn-primary" onClick={() => addProGiftRegistry(product.id)} >Add Products</Button></td>
                    <td class="em-actn-icons">                      
                      <Link
                        className="em-actn-icon"
                        to="#"
                        onClick={() => {
                          setSelectedData(product);
                          setShowReventScreen(true);
                          addClassOnBody();
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="38"
                          height="38"
                          viewBox="0 0 38 38"
                          fill="none"
                        >
                          <path
                            d="M19 22.1667C19.8398 22.1667 20.6453 21.8331 21.2392 21.2392C21.833 20.6453 22.1667 19.8399 22.1667 19C22.1667 18.1602 21.833 17.3547 21.2392 16.7609C20.6453 16.167 19.8398 15.8334 19 15.8334C18.1601 15.8334 17.3547 16.167 16.7608 16.7609C16.167 17.3547 15.8333 18.1602 15.8333 19C15.8333 19.8399 16.167 20.6453 16.7608 21.2392C17.3547 21.8331 18.1601 22.1667 19 22.1667Z"
                            stroke="#8780A0"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M33.25 19C30.2591 23.7358 24.8868 28.5 19 28.5C13.1132 28.5 7.74092 23.7358 4.75 19C8.39008 14.5002 12.654 9.5 19 9.5C25.346 9.5 29.6099 14.5002 33.25 19Z"
                            stroke="#8780A0"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </Link>
                          
                      <Link
                        className="em-actn-icon"
                        to="#"
                        onClick={() => {
                          setSelectedData(product);
                          setShowEditRegistry(true);
                          addClassOnBody();
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="38"
                          height="38"
                          viewBox="0 0 38 38"
                          fill="none"
                        >
                          <path
                            d="M20.615 9.22767L28.4525 17.0652L13.243 32.2762C12.9461 32.5732 12.5435 32.7401 12.1236 32.7402H4.94158V25.5582C4.94167 25.1383 5.10855 24.7356 5.4055 24.4387L20.615 9.22767ZM20.615 9.22767L25.0958 4.75L32.9333 12.5875L28.4541 17.0652L20.615 9.22767Z"
                            stroke="#8780A0"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </Link>
                      <Link
                        to="#"
                        className="btn-sm"
                        onClick={() => deleteHandler(product.id)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="38"
                          height="38"
                          viewBox="0 0 38 38"
                          fill="none"
                        >
                          <path
                            d="M30.0833 17.4166V32.3C30.0833 32.5519 29.9832 32.7936 29.8051 32.9717C29.6269 33.1499 29.3853 33.25 29.1333 33.25H8.86666C8.61471 33.25 8.37307 33.1499 8.19491 32.9717C8.01675 32.7936 7.91666 32.5519 7.91666 32.3V17.4166"
                            stroke="#8780A0"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M15.8333 26.9166V17.4166"
                            stroke="#8780A0"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M22.1667 26.9166V17.4166"
                            stroke="#8780A0"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12.6667 11.0833H25.3333M12.6667 11.0833H4.75M12.6667 11.0833V5.7C12.6667 5.44804 12.7668 5.20641 12.9449 5.02825C13.1231 4.85009 13.3647 4.75 13.6167 4.75H24.3833C24.6353 4.75 24.8769 4.85009 25.0551 5.02825C25.2332 5.20641 25.3333 5.44804 25.3333 5.7V11.0833M25.3333 11.0833H33.25"
                            stroke="#8780A0"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </Link>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
            <ToastContainer
              position="bottom-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="dark"
            />

            {/* MODEL CODE START HERE */}
            {/* <button onClick={openModal}>Open Modal</button> */}
            {/* <Modal
              isOpen={modalIsOpen}
              onRequestClose={closeModal}
              contentLabel="Example Modal"
            >
              {" "}
              <h1>Shoing Model Window Contents....</h1>
              <button onClick={closeModal}>Close Modal</button>
              <UsereventScreen data={selectedData} setData={setSelectedData} />
            </Modal> */}
          </table>
        )}
    </div>
  );
};

export default RegistereventListScreen;
